// src/components/mixer/ColorMixerUI/ColorCapsule.jsx
import React from 'react';

export default function ColorCapsule({ colour }) {
  // dynamic fill and partner color
  const fillColor = colour === 'RED' ? '#F23535' : '#2563EB';
  const partnerColour = colour === 'RED' ? 'BLUE' : 'RED';

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      width: '100%',
    }}>
      {/* Pill-stack SVG */}
      <div style={{ maxWidth: 125, width: '100%', marginTop: '1.5rem' }}>
        <svg viewBox="0 0 125 227" width="100%" height="auto" xmlns="http://www.w3.org/2000/svg">
          <rect width="125" height="227" rx="62.5" fill="#F4F4F4" />
          <rect x="2" y="4" width="121" height="219" rx="60.5" fill="#ECECEC" />
          <rect x="6" y="8" width="113" height="211" rx="56.5" fill="#E3E3E3" />
          <rect x="10" y="12" width="106" height="203" rx="53" fill={fillColor} />
        </svg>
      </div>

    
    </div>
  );
}
